import { render } from "./B2bTableMenuUsuarios.vue?vue&type=template&id=59e37eb2&scoped=true&lang=pug"
import script from "./B2bTableMenuUsuarios.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuUsuarios.vue?vue&type=script&lang=js"

import "./B2bTableMenuUsuarios.vue?vue&type=style&index=0&id=59e37eb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e37eb2"]])

export default __exports__